import mapboxgl from 'mapbox-gl';
import {markers} from '../mybus/enumerator/mybus-events.enum';
import AggloService from '../mybus/services/Agglo';
import {LineSchema, PointSchema, SymbolSchema} from '../mybus/schema/geojson.schema';
import {MapboxStyleEnum} from '../mybus/enumerator/mapBox-style.enum';
import ToasterService from '../mybus/services/toaster';
import ToastSchema from '../mybus/schema/toaster.schema';
import Translate from './translate';

/**
 * -------------
 * MapService
 * -------------
 * @description
 * gère la carte et les événements rattachés
 */
export default class MapService {
    /** contient l'objet mapbox */
    static map;

    /** nombre d'évenements (réinitialisés toutes les timeEvents) */
    static nbEvents = 0;

    /** nombres d'évenements total */
    static idEvent = 0;

    /** temps avant chaque réinitialisation de nbEvents (en millisecondes) */
    static timeEvents = 1000;

    /** nombre d'évenements maximum à afficher chaque timeEvents */
    static maxEvents = 20;

    /** s'incrémente pour chaque élément ajouté créant un id unique */
    static ids = 0;

    /** temps (millisecondes) avant disparition d'un event sur la carte */
    static displayNoneTimer = 5000;

    /** Tableau permettant d'avoir tous les IDS des layers présent sur la carte */
    static allLayerIds = [];

    /** variable permettant d'avoir l'identifiant du shape */
    static shapeId;

    /** stocke le dernier event */
    static lastEvent;

    constructor() {

    }

    /**
     * -------------
     * initMap
     * -------------
     * Initialisation de la map et positionnement
     * */
    static initMap = function (options) {
        (!options.center) ? options.center = [-8.9397, 45.8002] : '';
        (!options.zoom) ? options.zoom = 4.8 : '';
        (!options.style) ? options.style = 'mapbox://styles/fpacotte/ckc0ns7wz56841io16dkmxcfd' : '';
        (options.interactive.length) ? options.interactive = true : '';
        (options.scrollZoom.length) ? options.scrollZoom = true : '';

        return new Promise((successCallback) => {
            mapboxgl.accessToken = 'pk.eyJ1IjoiZnBhY290dGUiLCJhIjoiY2prbW1nNGRmMjYycjNxb2dqeHhkZ2YyYiJ9.agxnzWg9GLWfraGrgxPWAw';
            MapService.map = new mapboxgl.Map({
                container: options.id,
                style: options.style,
                center: options.center, // [lng, lat]
                zoom: options.zoom,
                geolocationControl: false,
                navigationControl: false,
                scaleControl: false,
                attributionControl: false,
                scrollZoom: options.scrollZoom,
                interactive: options.interactive
            });
            MapService.map.on('load', function () {
                MapService.load();
                successCallback();
            });
        });
    }

    /**
     * --------------
     * load
     * --------------
     * gestion des paramètres de la carte
     * */
    static load = function () {
        // load all markers
        $.each(markers, function (index, item) {
            MapService.map.loadImage(item.URL, function (error, image) {
                if (error) throw error;
                MapService.map.addImage(item.NAME, image);
            });
        });

        MapService.map.on('click', 'symbols', function (e) {
            MapService.map.flyTo({
                center: e.features[0].geometry.coordinates
            });
        });

        MapService.map.on('mouseenter', 'symbols', function () {
            MapService.map.getCanvas().style.cursor = 'pointer';
        });

        MapService.map.on('mouseleave', 'symbols', function () {
            MapService.map.getCanvas().style.cursor = '';
        });
    }

    /**
     * ------------------
     * intervalEvents
     * ------------------
     * Interval de temps permettant de gérer le nombre maximum d'événements à afficher chaque seconde
     * */
    static intervalEvents = function () {
        setInterval(function () {
            MapService.nbEvents = 0;
        }, MapService.timeEvents);
    }

    /**
     * -------------
     * drawEvent
     * -------------
     * affiche les agglos sur la carte
     * affiche à chaque événement un nouveau marker sur la carte
     * */
    static drawEvent = function () {
        // chargement des tous les types de marker
        let featureList = [];

        $.each(AggloService.networksList, function (index, item) {
            featureList.push({
                'type': 'Feature',
                'geometry': {
                    'type': 'Point',
                    'coordinates': item.region.center.coordinates
                }
            });
        });

        MapService.map.addSource('agglos', {
            'type': 'geojson',
            'data': {
                'type': 'FeatureCollection',
                'features': featureList
            }
        });

        MapService.map.addLayer({
            id: 'agglos',
            type: 'circle',
            source: 'agglos',
            paint: {
                [MapboxStyleEnum.CIRCLE_RADIUS]: 4,
                [MapboxStyleEnum.CIRCLE_COLOR]: '#FFFFFF',
                [MapboxStyleEnum.CIRCLE_STROKE_COLOR]: '#FFFFFF',
                [MapboxStyleEnum.CIRCLE_STROKE_WIDTH]: 0,
                [MapboxStyleEnum.CIRCLE_OPACITY]: 1
            }
        });

        // affichage des events
        MapService.intervalEvents();

        $(document).on("handleMessageRecieved", function (event, message) {
            if( MapService.lastEvent !== undefined &&
                MapService.lastEvent.first_name === message.first_name &&
                MapService.lastEvent.action === message.action ) {
            } else {
                MapService.nbEvents++;
                MapService.idEvent++;
                if (MapService.nbEvents <= MapService.maxEvents) {
                    const coord = message.coordinates_agglo.split(',');
                    let marker;
                    switch (message.action) {
                        case "VALIDATION":
                            marker = markers.VALIDATION;
                            break;
                        case "REGISTRATION":
                            marker = markers.REGISTRATION;
                            break;
                        case "ORDER":
                            marker = markers.ORDER;
                            break;
                        case "SMS_TICKET":
                            marker = markers.SMSTICKET;
                            break;
                        case "ITINERARY":
                            marker = markers.ITINERARY;
                            break;
                        case "TRANSFER":
                            marker = markers.TRANSFER;
                            break;
                        default:
                            console.error(Translate.print('mqtt.noEvent'));
                            break;
                    }
                    const lat = parseFloat(coord[0]);
                    coord[0] = parseFloat(coord[1]);
                    coord[1] = lat;
                    MapService.addPopupOnMap(coord, `<i class="fi fi-${marker.ICON}" class="event-map__icon"></i>`, {
                        hasTimeout: true,
                        className: 'event-map'
                    });
                    MapService.moveToTopLayer(markers.USERPOSITION.NAME);
                }
            }
            MapService.lastEvent = message;
        });
    }

    /**
     * -----------
     * centerLocationCurrent
     * -----------
     * Permet de centrer la carte sur la position de l'utilisateur
     */
    static centerLocationCurrent = function () {
        const layer = MapService.map.getSource('current-location')?._options?.data;
        MapService.map.flyTo({center: layer.geometry.coordinates});
    }

    /**
     * -----------
     * addSymbol
     * -----------
     * permet d'afficher un symbol (image) sur la carte
     */
    static addSymbol = function (point, color, id, type = 'geolocation', size = .5) {
        const circle = new SymbolSchema();
        circle.id = id;
        circle.source.data.geometry.coordinates = point;
        circle.layout['icon-size'] = size;

        if (type !== 'geolocation') {
            circle.layout = {
                'icon-image': `icon-${type}`,
                'icon-size': size,
                'icon-anchor': 'bottom',
            };
        }

        if (MapService.layerExist(id)) {
            MapService.resetLayer(id);
            if (MapService.sourceExist(id)) {
                MapService.resetSource(id);
            }
            const index = MapService.allLayerIds.findIndex(layer => layer === id);
            MapService.allLayerIds.splice(index, 1);
        }

        setTimeout(async () => {
            try {
                MapService.map.addLayer(circle);
                MapService.allLayerIds.push(id);
            } catch (e) {
                await MapService.manageError();
            }
        }, 0);
    }

    /**
     * -------------
     * getMapCenter
     * -------------
     * permet de récuperer les coordonées du centre de la carte
     */
    static getMapCenter = function () {
        return MapService.map.getCenter();
    }

    /**
     * -----------
     * changeVisibilityMarkers
     * -----------
     * Récupère les éléments présents sur la carte et change leurs visibilités selon la source et le boolean en paramètre
     */
    static changeVisibilityMarkers = function (source, isVisible) {
        $.each(MapService.map.getStyle().layers, (el) => {
            if (el.source === source) {
                MapService.map.setLayoutProperty(el.id, 'visibility', isVisible ? 'visible' : 'none');
            }
        });
    }

    /**
     * ---------
     * addPopupOnMap
     * ---------
     * Permet d'afficher une popup
     */
    static addPopupOnMap = function (coordinates, description = '', params = {
        className: 'event-map',
        hasTimeout: false
    }) {
        const popup = new mapboxgl.Popup({
            closeButton: false,
            closeOnClick: false,
            closeOnMove: false,
            className: params.className,
            anchor: 'bottom'
        }).setLngLat(coordinates)
            .setHTML(description)
            .addTo(MapService.map);

        if (params?.hasTimeout) {
            setTimeout(() => {
                popup.addClassName('close');
                setTimeout(() => {
                    popup.remove();
                }, 400);
            }, MapService.displayNoneTimer);
        }

        return popup;
    }

    /**
     * -------------------
     * addImageMarker
     * -------------------
     * Ajoute un point sur la map
     */
    static addImageMarker = function (coords, marker, id) {
        if (MapService.map) {
            MapService.map.addLayer({
                id: id,
                type: 'symbol',
                source: {
                    type: 'geojson',
                    data: {
                        type: 'FeatureCollection',
                        features: [
                            {
                                type: 'Feature',
                                geometry: {
                                    type: 'Point',
                                    coordinates: coords
                                }
                            }
                        ]
                    }
                },
                layout: {
                    'icon-image': marker.NAME,
                    'icon-size': marker.SIZE,
                    'icon-allow-overlap': true,
                    'visibility': 'visible',
                },
                paint: {
                    'icon-opacity': 1
                }
            });
            MapService.allLayerIds.push(id);
        }
    }

    /**
     * -------------------
     * addPoint
     * -------------------
     * Ajoute un point noir contour blanc sur la map
     */
    static addPoint = function (coords, id = '', color = '#000000', stroke = '#FFFFFF', radius = 8, strokeWidth = 2) {
        const circle = new PointSchema();
        circle.paint[MapboxStyleEnum.CIRCLE_RADIUS] = radius;
        circle.id = id;
        circle.source.data.geometry.coordinates = coords;
        circle.source.data.properties = {
            type: 'point'
        };
        circle.paint[MapboxStyleEnum.CIRCLE_COLOR] = color;
        circle.paint[MapboxStyleEnum.CIRCLE_STROKE_COLOR] = stroke;
        circle.paint[MapboxStyleEnum.CIRCLE_STROKE_WIDTH] = strokeWidth;
        MapService.map.addLayer(circle);

        MapService.allLayerIds.push(id);
    }

    /**
     * -------------------
     * addControl
     * -------------------
     * Ajoute les controls sur la map
     */
    static addControl = function () {
        if( MapService.map ) {
            const geolocate = new mapboxgl.GeolocateControl({
                compact: false
            });
            const zoom = new mapboxgl.NavigationControl({
                showZoom: true,
                visualizePitch: true,
                showCompass: false
            });
            MapService.map.addControl(geolocate, 'bottom-right');
            MapService.map.addControl(zoom, 'bottom-right');

            $(document).on('click', '.mapboxgl-ctrl-geolocate', function() {
                if( !$(this).hasClass('loading') ) {
                    $(this).addClass('loading');

                    const loader =
                        '<svg class="loader" viewBox="0 0 100 100">' +
                        '<g class="loader__form">' +
                        '<circle class="loader__bg"' +
                        'fill="#e75c0b"' +
                        'cx="50"' +
                        'cy="50"' +
                        'r="50"/>' +
                        '<circle class="loader__left"' +
                        'fill="#fff"' +
                        'cx="10"' +
                        'cy="50"' +
                        'r="10"/>' +
                        '<circle class="loader__right"' +
                        'fill="#fff"' +
                        'cx="90"' +
                        'cy="50"' +
                        'r="10"/>' +
                        '</g>' +
                        '</svg>';
                    $(this).append(loader);
                }
            })

            geolocate.on('geolocate', function() {
                $('.mapboxgl-ctrl-geolocate').removeClass('loading');
                $('.mapboxgl-ctrl-geolocate').children('svg').remove();
            });
        }
    }


    /**
     * --------------
     * resetAllLayers
     * --------------
     * retire tout les layers (points/lignes etc.)
     */
    static resetAllLayers = function (excludeLayers = []) {
        if (MapService.allLayerIds?.length) {
            MapService.allLayerIds.forEach((value) => {
                if (!!MapService.map.getLayer(value) && !excludeLayers.includes(value)) {
                    MapService.map.removeLayer(value);
                    MapService.map.removeSource(value);
                }
            });
        }
        MapService.allLayerIds = excludeLayers;
    }

    /**
     * ----------
     * layerExist
     * ----------
     * permet de check si le layer exist déjà sur la carte
     */
    static layerExist = function (idLayer) {
        return (!!MapService.map && !!idLayer && !!MapService.map.getLayer(idLayer));
    }

    /**
     * ----------
     * sourceExist
     * ----------
     * permet de check si la source existe déjà sur la carte
     */
    static sourceExist = function (idSource) {
        return (!!MapService.map && !!idSource && !!MapService.map.getSource(idSource));
    }

    /**
     * --------
     * removePoint
     * --------
     * Supprime les layer et source si elles existent
     */
    static removePoint = function (id) {
        return new Promise((resolve) => {
            if (MapService.layerExist(id)) {
                MapService.map.removeLayer(id);
                if (MapService.sourceExist(id)) {
                    MapService.map.removeSource(id);
                }
            }
            resolve();
        });
    }

    /**
     * ---------
     * moveToTopLayer
     * ---------
     * déplace le layer sélectionné et le positionne sur le premier plan
     */
    static moveToTopLayer(id) {
        if (MapService.layerExist(id)) {
            MapService.map.moveLayer(id);
        }
    }

    /**
     * --------
     * addShape
     * --------
     * permet d'afficher le tracer de la ligne sur la carte
     */
    static addShape(shape, color, id, dashed = false) {
        return new Promise(resolved => {
            const line = new LineSchema();
            line.id = id;
            line.source.data.geometry = shape;
            line.source.data.properties.type = 'line';
            line.paint['line-width'] = 4;
            line.paint['line-color'] = color;
            if (dashed) {
                line['line-cap'] = 'round';
                line.paint['line-width'] = 3;
                line.paint['line-dasharray'] = [0.5, 2];
            }
            setTimeout(() => {
                if (!MapService.allLayerIds.includes(id)) {
                    MapService.map.addLayer(line);
                    MapService.allLayerIds.push(id);
                    MapService.shapeId = id;
                    resolved(true);
                }
            });
        });
    }

    /**
     * -----------
     * resetLayer
     * -----------
     * Supprime un layer de la map à partir de son id
     */
    static resetLayer = function (id) {
        MapService.removeLayer(id);
    }

    /**
     * -----------
     * resetSource
     * -----------
     * Supprime une source de la map à partir de son id
     */
    static resetSource = function (id) {
        MapService.removeSource(id);
    }

    /**
     * -----------
     * manageError
     * -----------
     * affiche un toaster d'erreur
     */
    static manageError = async function () {
        ToasterService.showToaster(new ToastSchema({text: Translate.print('toaster.map.content')}));
    }
}
